import React, {Component} from 'react'
import {Actions} from 'jumpstate'
import {connect} from 'react-redux'
import {Grid, Row, Col, Alert} from 'react-bootstrap'
import {Form} from 'react-form'
import PaymentDonateForm from './PaymentDonateForm'
import ProductForm from './ProductForm'
import showToastr from '../../utils/showToastr'
import validatePaymentDonate from '../../utils/validatePaymentDonate'
import ErrorHandler from '../../utils/ErrorHandler'
import './Layout/Donate.css'
import ShopReport from './ShopReport'

class DonateScreen extends Component {
  constructor (props) {
    super(props)

    this.state = {
      message: {status: '', context: ''},
      isLoading: false,
      items: [],
      total: 0
    }

    this.submitForm = this.submitForm.bind(this)
  }

  componentWillMount () {
    if (this.props.product.kind !== 'eyd_ta_eyd') {
      return Actions.loadProducts('eyd_ta_eyd').then((data) => {
        const items = data.reduce((o, item, index) => ({...o, [`p_${data[index].id}`]: 1}), {})
        this.setState({
          items
        })
      })
    }

    const items = this.props.product.list.reduce((o, item, index) => ({...o, [`p_${this.props.product.list[index].id}`]: 1}), {})
    this.setState({
      items
    })
  }

  componentWillReceiveProps (props) {
    if (props.product.list.length > 0 && props.product.kind === 'eyd_ta_eyd') {
      const items = props.product.list.reduce((o, item) => ({...o, [`p_${item.id}`]: 1}), {})
      this.setState({
        items
      })
    }
  }

  submitForm (values) {
    const {items, total} = this.state
    const {list} = this.props.product
    if (total < 1) { return undefined }

    this.setState({isLoading: true})

    let formData = {
      phone: values.phone || this.props.user.mobile,
      address: values.address,
      items: list.filter((product) => items[`p_${product.id}`] > 0).map((product) => ({product_id: product.id, count: items[`p_${product.id}`]}))
    }

    Actions.buy(formData).then((res) => {
      this.setState({isLoading: false})
      showToastr('success', 'حمایت', 'از حمایت شما سپاسگزاریم')
      window.location = res.redirectUrl
    }).catch((err) => {
      let eh = new ErrorHandler(err)
      this.setState({message: eh.message, isLoading: false})
      eh.setFormErrors(this.refs.donate)
      eh.showToastrIn('حمایت')
    })
  }

  render () {
    const { auth, product } = this.props
    const { items, message, isLoading, total } = this.state
    const getAlertClass = () => {
      if (total > 5) { return 'info' }
      if (total > 1) { return 'success' }
      if (total === 1) { return 'warning' }
      return 'danger'
    }
    return (
      <div id="donate-screen">
        <Grid>
          <Row>
            {product.list.length > 0 && <Col xs={12}>
              <Row className="title">
                <h2>حمایت</h2>
              </Row>
              <Row>
                <Form
                  products={product.list}
                  defaultValues={items}
                  onChange={(form) => this.setState({
                    items: form.values,
                    total: product.list.reduce((sum, product) => (sum += form.values[`p_${product.id}`]), 0)
                  })}
                >
                  {ProductForm}
                </Form>
              </Row>
              <Row className="wrapper">
                <Col md={11} xs={12} className="donate-box">
                  <Alert bsStyle={getAlertClass()}><ShopReport items={items} products={product.list} /></Alert>
                  <div className="donate-form">
                    <Form
                      ref="donate"
                      validate={validatePaymentDonate}
                      disable={isLoading}
                      items={items}
                      message={message}
                      onSubmit={this.submitForm}
                      isAuthenticated={auth.isAuthenticated}
                      isLoading={isLoading}>
                      {PaymentDonateForm}
                    </Form>
                  </div>
                </Col>
              </Row>
            </Col>}
          </Row>
        </Grid>
      </div>
    )
  }
}

DonateScreen.fetchData = () => {
  return Actions.loadProducts('eyd_ta_eyd')
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user.currentUser,
    product: state.product
  }
}

export default connect(mapStateToProps)(DonateScreen)



// WEBPACK FOOTER //
// ./src/components/Donate/DonateScreen.js